import React from 'react';
import { Button, Form } from 'antd';
import { FormattedMessage } from 'react-intl';
import NotesContext from './NotesContext';
import message from '../../Containers/ManualSearchV2/ManualSearchMessages';

function NotesCancelButton() {
  const { onCancel } = React.useContext(NotesContext);

  const handleButtonClick = e => {
    e.preventDefault();
    onCancel();
  };

  return (
    <Form.Item>
      <Button onClick={handleButtonClick} shape="round">
      <FormattedMessage {...message.cancelLabel} />
      </Button>
    </Form.Item>
  );
}

export default NotesCancelButton;
